import React from 'react';

import AddIcon from '@material-ui/icons/Add';
import CloseIcon from '@material-ui/icons/Close';
import styled from 'styled-components';
import { StyledTypography } from 'styles/common';

const IconContainer = styled.span`
  svg {
    font-size: 18px;
    vertical-align: text-top;
    margin-right: 0.1rem;
  }
`;

function TextToggle({ enabled = false, toggleHandler, enabledText, disabledText, topGutter = 0, bottomGutter = 0 }) {
  return enabled ? (
    <StyledTypography
      display="block"
      customColor="primary"
      variant="body2"
      onClick={() => {
        toggleHandler(false);
      }}
      topGutter={topGutter}
      bottomGutter={bottomGutter}
    >
      <IconContainer>
        <CloseIcon />
      </IconContainer>{' '}
      {enabledText}
    </StyledTypography>
  ) : (
    <StyledTypography
      topGutter={topGutter}
      bottomGutter={bottomGutter}
      display="block"
      customColor="textHeading"
      variant="body2"
      onClick={() => {
        toggleHandler(true);
      }}
    >
      <IconContainer>
        {' '}
        <AddIcon />{' '}
      </IconContainer>{' '}
      {disabledText}
    </StyledTypography>
  );
}

export default TextToggle;
